import React, { useEffect, useState } from "react";

function InterviewTable({
  object,
  categories,
  descriptions,
  formState,
  styles,
}) {
  console.warn("object", object?.interviewForm);

  const [interviewObject, setInterview] = useState({});

  useEffect(() => {
    setInterview({ ...object?.interviewForm });
  }, [object]);

  // const styles = {
  //   content: { fontSize: "1.2rem" },
  //   header: { fontSize: "1.5rem" },
  // };
  return (
    <table
      className="textwrap"
      style={{
        width: "100%",
        boxSizing: "border-box",
        borderCollapse: "collapse",
        borderRadius: "12px 12px 0 0",
        border: "1px solid #ddd",
        fontSize: styles.content.fontSize,
      }}
    >
      <thead style={{ backgroundColor: "#E09552", color: "white" }}>
        <tr>
          {categories.map((category) => (
            <th
              key={category.key}
              style={{
                textAlign: "center",
                padding: "5px 10px",
                fontWeight: "normal",
                fontSize: styles.content.fontSize,
              }}
            >
              {category.label}
            </th>
          ))}
          <th
            style={{
              textAlign: "center",
              fontWeight: "normal",
              padding: "0 10px",
              fontSize: styles.content.fontSize,
            }}
          >
            Points
          </th>
        </tr>
      </thead>
      <tbody>
        {descriptions.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {categories.map((category, colIndex) => (
              <td
                key={category.key}
                style={{
                  verticalAlign: "middle",
                  border: "1px solid #ddd",
                  borderLeft: "0",
                  cursor: "pointer",
                  fontSize: styles.content.fontSize,
                }}
                // onClick={() => handleCheckboxChange(category.key, row.value)}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <input
                    disabled={object}
                    type="radio"
                    value={row.value}
                    checked={interviewObject[category.key] === row.value}
                    style={{
                      alignSelf: "center",
                      marginLeft: "10px",
                      width: "15px",
                      height: "15px",
                      borderRadius: "50%",
                      appearance: "none",
                      border: "1px solid #ddd",
                      outline: "none",
                      cursor: "pointer",
                      backgroundColor:
                        interviewObject[category.key] === row.value
                          ? "#E09552"
                          : "white",
                    }}
                  />
                  <span style={{ flex: "1" }}>
                    {row.text?.[colIndex] || "N/A"}
                  </span>
                </div>
              </td>
            ))}
            <td
              style={{
                textAlign: "center",
                verticalAlign: "middle",
                border: "1px solid #ddd",
                borderRight: "0",
                fontSize: styles.content.fontSize,
              }}
            >
              {row.value}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default InterviewTable;
